var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-container"},[_c('div',[_c('h3',{staticClass:"drawer-title"},[_vm._v("系统布局配置")]),_c('div',{staticClass:"drawer-item"},[_c('span',[_vm._v("主题色")]),_c('theme-picker',{staticStyle:{"float":"right","margin":"-3px 8px 0 0","height":"26px"},on:{"change":_vm.onThemeChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }